import styled from 'styled-components'

/* Cap results area to ~75% of viewport minus the input header height */
// tabIndex={-1}: Chrome implicitly focuses overflow-y:auto containers for keyboard scrolling.
// Scroll-into-view is handled by GlobalSearchListbox, so this should not be a tab stop.
export const GlobalSearchResultsListStyled = styled.div.attrs({
  tabIndex: -1,
})`
  max-height: calc(75vh - ${(props) => props.theme.typography.pxToRem(56)});
  overflow-y: auto;
  outline: none;
`
